if (window.location.pathname.startsWith('/act/')) {
  import('./act.app');
} else {
  import('./rcg-assist-ng.app');
}
